import * as types from '@/constants/mutationTypes';

const state = {
  loaderRun: false
};
const getters = {
  loaderRun: (state) => state.loaderRun
};
const actions = {
  setLoaderRun ({ commit }, data) {
    commit(types.SET_LOADER_RUN, { data });
  }
};
const mutations = {
  [types.SET_LOADER_RUN] (state, { data }) {
    state.loaderRun = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
